import type { JSX } from 'react';

import { cn } from '@change/ds-utils';

import { Separator, Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';

import { useTrackView } from 'src/app/shared/hooks/tracking';

import { ClosePetition } from './components/ClosePetition';
import { DeclareVictory } from './components/DeclareVictory';
import { ReopenPetition } from './components/ReopenPetition';
import { useSettings } from './hooks/useSettings';

export function Settings(): JSX.Element {
	const {
		data: { petitionStatus, statusLabel, statusColor, statusIcon },
	} = useSettings();

	useTrackView('petition_settings_view');

	return (
		<div className="container">
			<Text size="x-small" variant="heading">
				<Translate value="corgi.petition.edit.settings.petition_status" />
			</Text>
			<Text size="x-small" variant="heading" className={cn(statusColor, 'ml-2')}>
				{statusIcon && <Icon icon={statusIcon} className="mr-1" />}
				<Translate value={statusLabel} />
			</Text>
			{petitionStatus === 'PUBLISHED' && <Separator className="mt-8" />}
			<div className="flex sm:flex-col md:flex-row md:gap-20">
				{petitionStatus === 'PUBLISHED' && <DeclareVictory />}
			</div>
			<Separator className="mt-8" />
			<div className="flex sm:mb-8 sm:flex-col md:mb-12 md:flex-row md:gap-20">
				{(petitionStatus === 'PUBLISHED' || petitionStatus === 'VICTORY') && <ClosePetition />}
				{petitionStatus === 'CLOSED' && <ReopenPetition />}
			</div>
		</div>
	);
}
